export default __webpack_public_path__ + "static/triggered-spotlight-dark-bbc38d08f12d15e051e37e9cf090e58d.png";